export default "__VITE_ASSET__7iGjPZLo__"